import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const DropDownArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 14 9">
    <path
      d="M6.31853 8.09591L0.747503 1.99634C0.670895 1.91213 0.610492 1.81809 0.566295 1.7142C0.522098 1.61064 0.5 1.4995 0.5 1.38077C0.5 1.14364 0.57322 0.93748 0.719659 0.762294C0.866098 0.587431 1.05909 0.5 1.29864 0.5H13.0347C13.2742 0.5 13.4672 0.588399 13.6137 0.765198C13.7601 0.941674 13.8333 1.14767 13.8333 1.38319C13.8333 1.44223 13.7507 1.64661 13.5854 1.99634L8.0148 8.09591C7.88693 8.23625 7.75463 8.33869 7.61792 8.40321C7.4812 8.46774 7.33078 8.5 7.16667 8.5C7.00255 8.5 6.85213 8.46774 6.71542 8.40321C6.5787 8.33869 6.4464 8.23625 6.31853 8.09591Z"
      fill="#000000"
    />
  </SvgIcon>
);

export const TableHeaderUpArrowIcon: React.FC = () => (
  <DropDownArrowIcon
    sx={{
      fontSize: "12px",
    }}
  />
);

export const TableHeaderDownArrowIcon: React.FC = () => (
  <DropDownArrowIcon
    sx={{
      transform: "rotate(180deg)",
      fontSize: "12px",
    }}
  />
);
